import analysis from './data/analysis'
import requestsAnalysis from './data/requests-analysis'
import usersAnalysis from './data/users-analysis'
import userSite from './data/users'
import engineers from './data/engineers'
import employees from './data/employees'
import office from './data/office'

export default {
  mainDataHeader: {
    analysis,
    requestsAnalysis,
    usersAnalysis,
    userSite,
    engineers,
    employees,
    office,
  },
}
